import { Link } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";
import { GlassCard } from "@/components/common/GlassCard";
import { Button } from "@/components/ui/button";
import { APPS_HOME_PATH } from "@/lib/apps";

interface ComingSoonProps {
  title: string;
  description: string;
}

export function ComingSoon({ title, description }: ComingSoonProps) {
  return (
    <section className="flex flex-1 items-center justify-center p-6">
      <GlassCard className="max-w-lg w-full text-center">
        <Construction className="mx-auto mb-4 h-12 w-12 text-violet-400" />
        <h1 className="mb-2 text-2xl font-semibold text-white">{title}</h1>
        <p className="mb-6 text-slate-300">{description}</p>
        <p className="mb-6 text-sm text-slate-400">This module is coming soon.</p>
        <Button asChild variant="outline">
          <Link to={APPS_HOME_PATH}>
            <ArrowLeft className="h-4 w-4" />
            Back to Dashboard
          </Link>
        </Button>
      </GlassCard>
    </section>
  );
}
